// import React, { useState } from "react";
// import Styles from "../../assets/scss/ItemCategories/ItemCategoriesTable.module.scss";
// import { FaTrash } from "react-icons/fa";
// import Pagination from "../../Components/Common/Pagination";
// import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";
// import PopupWrapper from "../../Components/Common/PopupWrapper";
// import AddItemCategoriesBelow from "./AddItemCategoriesBelow";

// const ItemCategoriesTableBelow = () => {

//     const [search, setSearch] = useState("");
//     const [currentPage, setCurrentPage] = useState(1);
//     const [limit, setLimit] = useState(10);
//     const [showPopup, setShowPopup] = useState(false);


//     // DELETE POPUP STATES
//     const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//     const [selectedItem, setSelectedItem] = useState(null);

//     // Dummy Data
//     const [items, setItems] = useState([
//         { id: 1, name: "Rice" },
//         { id: 2, name: "Wheat" },
//         { id: 3, name: "Sugar" },
//         { id: 4, name: "Dal" },
//         { id: 5, name: "Oil" },
//         { id: 6, name: "Salt" },
//         { id: 7, name: "Rava" },
//         { id: 8, name: "Spices" },
//         { id: 9, name: "Fruits" },
//         { id: 10, name: "Vegetables" },
//     ]);

//     const filteredItems = items.filter((item) =>
//         item.name.toLowerCase().includes(search.toLowerCase())
//     );

//     const totalPages = Math.ceil(filteredItems.length / limit);

//     const currentRows = filteredItems.slice(
//         (currentPage - 1) * limit,
//         currentPage * limit
//     );

//     // OPEN DELETE POPUP
//     const openDeletePopup = (item) => {
//         setSelectedItem(item);
//         setDeleteModalOpen(true);
//     };

//     // CONFIRM DELETE
//     const confirmDelete = () => {
//         if (selectedItem) {
//             setItems(items.filter((i) => i.id !== selectedItem.id));
//         }
//         setDeleteModalOpen(false);
//         setSelectedItem(null);
//     };

//     return (
//         <div className={Styles.parent}>

//             <div className={Styles.box}>

//                 {/* Search + Clear + Add */}
//                 <div className={Styles.headerRow}>
//                     <div className={Styles.leftControls}>
//                         <input
//                             type="text"
//                             placeholder="Search items..."
//                             value={search}
//                             onChange={(e) => setSearch(e.target.value)}
//                             className={Styles.searchBox}
//                         />

//                         <button
//                             className={Styles.clearBtn}
//                             onClick={() => {
//                                 setSearch("");
//                                 setCurrentPage(1);
//                             }}
//                         >
//                             Clear All
//                         </button>
//                     </div>

//                     <button className={Styles.addBtn} onClick={() => setShowPopup(true)}>
//                         + Add New Item
//                     </button>
//                 </div>

//                 {/* TABLE */}
//                 <div className={Styles.tableWrapper}>
//                     <table className={Styles.customTable}>
//                         <thead>
//                             <tr>
//                                 <th>S.No</th>
//                                 <th>Item Name</th>
//                                 <th className={Styles.actionCol}>Action</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {currentRows.map((item, index) => (
//                                 <tr key={item.id}>
//                                     <td>{(currentPage - 1) * limit + index + 1}</td>
//                                     <td>{item.name}</td>
//                                     <td className={Styles.actionCol}>
//                                         <FaTrash
//                                             className={Styles.deleteIcon}
//                                             onClick={() => openDeletePopup(item)}
//                                         />
//                                     </td>
//                                 </tr>
//                             ))}

//                             {currentRows.length === 0 && (
//                                 <tr>
//                                     <td colSpan="3" className={Styles.noData}>
//                                         No items found
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>

//                     <div className={Styles.paginationContainer}>
//                         <Pagination
//                             currentPage={currentPage}
//                             totalPages={totalPages}
//                             onPageChange={(page) => setCurrentPage(page)}
//                         />

//                         <select
//                             className={Styles.inputsbtn}
//                             value={limit}
//                             onChange={(e) => {
//                                 setLimit(Number(e.target.value));
//                                 setCurrentPage(1);
//                             }}
//                         >
//                             <option value={10}>10 rows</option>
//                             <option value={25}>25 rows</option>
//                             <option value={50}>50 rows</option>
//                         </select>
//                     </div>
//                 </div>
//             </div>

//             {/* USE SAME LOGOUT POPUP FOR DELETE ✔ */}
//             <DeleteConfirmModalLogout
//                 isOpen={deleteModalOpen}
//                 onConfirm={confirmDelete}
//                 onCancel={() => {
//                     setDeleteModalOpen(false);
//                     setSelectedItem(null);
//                 }}
//                 title="Are You Sure?"
//                 heading="Delete Item"
//                 content={`Are you sure you want to delete "${selectedItem?.name}"? This action cannot be restored.`}
//             />
//             {showPopup && (
//                 <PopupWrapper onClose={() => setShowPopup(false)}>
//                     <AddItemCategoriesBelow onClose={() => setShowPopup(false)} />
//                 </PopupWrapper>
//             )}



//         </div>
//     );
// };

// export default ItemCategoriesTableBelow;

import React, { useState, useEffect } from "react";
import Styles from "../../assets/scss/ItemCategories/ItemCategoriesTable.module.scss";
import { FaTrash } from "react-icons/fa";
import Pagination from "../../Components/Common/Pagination";
import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import AddItemCategoriesBelow from "./AddItemCategoriesBelow";
import settingStyles from "../../assets/scss/Settings/Settings.module.scss";

import { useGetItemsByStoreIdsQuery, useGetUserByIdQuery, useRemoveItemCategoryMutation } from "../../slices/admin/admin";
import { getUserInfo } from "../../utils/user.util";
import { toast } from "react-toastify";

const ItemCategoriesTableBelow = () => {



    const localUser = getUserInfo();
    const userId = localUser?._id;

    const { data: storeDats, refetch } = useGetUserByIdQuery(userId, { skip: !userId });
    const [removeItemCategory, { isLoading: isDeleting }] =
        useRemoveItemCategoryMutation();


    // console.log(storeDats, "storeDats22");




    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showPopup, setShowPopup] = useState(false);

    // DELETE POPUP STATES
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const offset = currentPage;

    const storeId = storeDats?.result?.[0]?.store?._id;

    const { data, isLoading } = useGetItemsByStoreIdsQuery(
        {
            storeId,
            offset,
            limit,
            search,
        },
        {
            skip: !storeId,
        }
    );


    const items = data?.items || [];
    const totalCount = data?.total || items.length;
    const totalPages = Math.ceil(totalCount / limit);

    // Reset page on search
    useEffect(() => {
        setCurrentPage(1);
    }, [search, limit]);

    // OPEN DELETE POPUP
    const openDeletePopup = (item) => {
        setSelectedItem(item);
        setDeleteModalOpen(true);
    };
const confirmDelete = async () => {
  if (!selectedItem?._id) return;

  try {
    await removeItemCategory(selectedItem._id).unwrap();

    toast.success("Item category deleted successfully");

    setDeleteModalOpen(false);
    setSelectedItem(null);

    refetch(); // 🔥 table auto refresh
  } catch (error) {
    toast.error(
      error?.data?.message || "Failed to delete item category"
    );
  }
};



    return (
        <div className={Styles.parent}>
  <div className={settingStyles.headerRow}>
                <h2 className={settingStyles.header}>Item Categories</h2>
            </div>
            <div className={Styles.box}>

                {/* Search + Clear + Add */}
                <div className={Styles.headerRow}>
                    <div className={Styles.leftControls}>
                        <input
                            type="text"
                            placeholder="Search items..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className={Styles.searchBox}
                        />

                        <button
                            className={Styles.clearBtn}
                            onClick={() => {
                                setSearch("");
                                setCurrentPage(1);
                            }}
                        >
                            Clear All
                        </button>
                    </div>

                    <button
                        className={Styles.addBtn}
                        onClick={() => setShowPopup(true)}
                    >
                        + Add New Item
                    </button>
                </div>

                {/* TABLE */}
                <div className={Styles.tableWrapper}>
                    <table className={Styles.customTable}>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Item Name</th>
                                <th className={Styles.actionCol}>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {isLoading && (
                                <tr>
                                    <td colSpan="3" className={Styles.noData}>
                                        Loading...
                                    </td>
                                </tr>
                            )}

                            {!isLoading && items.map((item, index) => (
                                <tr key={item._id}>
                                    <td>{(currentPage - 1) * limit + index + 1}</td>
                                    <td>{item.itemCategory}</td>
                                    <td className={Styles.actionCol}>
                                        <FaTrash
                                            className={Styles.deleteIcon}
                                            onClick={() => openDeletePopup(item)}
                                        />
                                    </td>
                                </tr>
                            ))}

                            {!isLoading && items.length === 0 && (
                                <tr>
                                    <td colSpan="3" className={Styles.noData}>
                                        No items selected for this store
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>

                    <div className={Styles.paginationContainer}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                        />

                        <select
                            className={Styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* DELETE CONFIRM POPUP */}
           <DeleteConfirmModalLogout
  isOpen={deleteModalOpen}
  onConfirm={confirmDelete}
  onCancel={() => {
    setDeleteModalOpen(false);
    setSelectedItem(null);
  }}
  title="Are You Sure?"
  heading="Delete Item"
  content={`Are you sure you want to delete "${selectedItem?.itemCategory}"? This action cannot be restored.`}
/>


            {showPopup && (
                <PopupWrapper onClose={() => setShowPopup(false)}>
                    <AddItemCategoriesBelow 
                    onClose={() => setShowPopup(false)}
                    selectedCategoryIds={items.map((i) => i._id)}
                    />
                </PopupWrapper>
            )}

        </div>
    );
};

export default ItemCategoriesTableBelow;

